<script>
const {
    rem: { parseStyle, rem },
} = window.FEGOUtils;

export default {
    name: "welcome-easy-swiper",
    props: {
        tpl: {},
        delay: {
            type: Number,
            default: 5000
        },
        loop: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            current: 0,
        };
    },
    computed: {
        rootClass() {
            let r = [];
            let { autoWidth, autoHeight } = this.tpl.props || {};
            if (autoWidth) {
                r.push(" auto-width");
            }

            if (autoHeight) {
                r.push("auto-height");
            }

            return r;
        },
        activeChild() {
            return (
                this.tpl.children.find((i) => {
                    return i.id === this.current;
                }) || this.tpl.children[0]
            );
        }
    },

    methods: {
        setStyle(tpl) {
            let { style } = tpl;
            return style && parseStyle(style);
        },
        setRem(pixel) {
            return rem(pixel);
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/render/core.vue